var ReactNative = require('react-native')
module.exports = ReactNative.NativeModules.Contacts
